const config = {
    cloudfront_url : "https://dkp7phw86ifvp.cloudfront.net/",
    url: 'https://edge.webtonicadmin.co.za/api/frontend',
    clientKey: 'UNLEASH_CLIENT_KEY',
    refreshInterval: 120, // How often (in seconds) the client should poll the proxy for updates
    appName: 'default', // The name of your application. It's only used for identifying your application
}

export default config